var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Watch } from "vue-facing-decorator";
import { RegionsClient, RegionModel, GetRegionListPaginatedQuery, PaginatedEnumerableOfRegionModel, CountriesClient, UpdateRegionCommand, CreateRegionCommand } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { TextHelper } from "@/app/utils/text-helper";
const countryClient = new CountriesClient(window.apiUrl);
const regionsClient = new RegionsClient(window.apiUrl);
let RegionsVue = class RegionsVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.working = false;
        this.searchAttempted = false;
        // models
        this.query = new GetRegionListPaginatedQuery({
            pageNo: 1,
            pageSize: 100,
        });
        this.data = new PaginatedEnumerableOfRegionModel();
        // arrays
        this.countries = [];
    }
    created() {
        // data will be loaded only after we get lookups.
        this.getLookups();
    }
    ;
    // get
    search() {
        if (this.working)
            return;
        if (!this.query)
            return;
        this.working = true;
        regionsClient
            .getListPaginated(this.query)
            .then(response => {
            if (!response)
                return;
            this.data = response;
            this.query.pageNo = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    getLookups() {
        countryClient
            .getList()
            .then((response) => {
            this.countries = [{ value: null, text: TextHelper.emptyListItemName }].concat((response || []).map((item) => {
                return {
                    value: item.countryId || null,
                    text: item.countryName || ""
                };
            }));
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.search();
        });
    }
    ;
    // set
    add() {
        let region = new RegionModel({
            regionId: 0,
            countryId: null,
            regionName: ""
        });
        if (!this.data.records)
            this.data.records = new Array();
        this.data.records.unshift(region);
    }
    ;
    save(region) {
        if (!region.regionName) {
            Notifier.onError("Please enter a region name.");
            return;
        }
        let promise = () => {
            return region.regionId
                ? regionsClient.update(region.regionId, new UpdateRegionCommand({ requestModel: region }))
                : regionsClient.add(new CreateRegionCommand({ requestModel: region }));
        };
        promise()
            .then(() => {
            Notifier.onOk();
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.search();
        });
    }
    ;
    purge(region) {
        if (!region.regionId && this.data.records) {
            this.data.records.splice(this.data.records.indexOf(region), 1);
            return;
        }
        this.$confirmModal.show("Are you sure that you want to permanently delete this region? This action cannot be undone.", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            regionsClient
                .delete(region.regionId)
                .then(() => {
                Notifier.onOk();
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.search();
            });
        });
    }
    ;
    // computed
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
};
__decorate([
    Watch("query.pageNo"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], RegionsVue.prototype, "search", null);
RegionsVue = __decorate([
    Component({
        name: "RegionsVue"
    })
], RegionsVue);
export default RegionsVue;
